import { stepConfigItem } from './types';

const stepsSchema: stepConfigItem[] = [
  { id: 'sex', slug: 'sex' },
  { id: 'dateOfBirth', slug: 'birth-date', shouldBackendValidate: true },
  { id: 'heightValue', slug: 'height', shouldBackendValidate: true },
  {
    id: 'weightValue',
    slug: 'weight',
    shouldBackendValidate: true,
  },
  {
    id: 'dietMode',
    slug: 'diet-mode',
    fork: {
      chooseChild: (state: { dietMode: string }) =>
        state.dietMode !== 'stabilization' ? 'goalWeight' : 'activityLevel',
      children: {
        goalWeight: [
          { id: 'goalWeightValue', slug: 'goal-weight', shouldBackendValidate: true },
          { id: 'spontaneousActivityLevel', slug: 'spontaneous-activity-level' },
          { id: 'activityLevel', slug: 'activity-level' },
          { id: 'dietType', slug: 'diet-type' },
          { id: 'summary', slug: 'summary' },
        ],
        activityLevel: [
          { id: 'spontaneousActivityLevel', slug: 'spontaneous-activity-level' },
          { id: 'activityLevel', slug: 'activity-level' },
          { id: 'dietType', slug: 'diet-type' },
          { id: 'summary', slug: 'summary' },
        ],
      },
    },
  },
];

export default stepsSchema;
